/* MIKOO shop the look: one card open at a time, anchored to its dot, kept inside the photo. */
(function () {
  if (customElements.get('mikoo-shop-the-look')) return;

  var GAP = 14; /* space between the dot and the card, px */
  var EDGE = 8; /* minimum space from the photo's edge, px */

  class MikooShopTheLook extends HTMLElement {
    connectedCallback() {
      this.spots = Array.from(this.querySelectorAll('.mk-look__spot'));
      var self = this;
      this.spots.forEach(function (spot) {
        spot.querySelector('.mk-look__dot').addEventListener('click', function () {
          spot.classList.contains('is-open') ? self.close(spot) : self.open(spot);
        });
      });
      this.onOutside = function (event) { if (!self.contains(event.target)) self.closeAll(); };
      this.onKey = function (event) {
        if (event.key !== 'Escape') return;
        var open = self.querySelector('.mk-look__spot.is-open');
        if (open) { self.close(open); open.querySelector('.mk-look__dot').focus(); }
      };
      document.addEventListener('click', this.onOutside);
      document.addEventListener('keydown', this.onKey);
      this.revealOnce();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onOutside);
      document.removeEventListener('keydown', this.onKey);
    }

    open(spot) {
      this.closeAll(spot);
      var card = spot.querySelector('.mk-look__card');
      clearTimeout(spot.mkHide);
      card.hidden = false;
      this.place(spot, card);
      /* read layout once so the card starts from its closed state, then let it grow */
      void card.offsetWidth;
      spot.classList.add('is-open');
      spot.querySelector('.mk-look__dot').setAttribute('aria-expanded', 'true');
    }

    close(spot) {
      if (!spot.classList.contains('is-open')) return;
      var card = spot.querySelector('.mk-look__card');
      spot.classList.remove('is-open');
      spot.querySelector('.mk-look__dot').setAttribute('aria-expanded', 'false');
      /* hide after the closing motion; reopening before then simply reverses it */
      spot.mkHide = setTimeout(function () { if (!spot.classList.contains('is-open')) card.hidden = true; }, 260);
    }

    closeAll(except) {
      var self = this;
      this.spots.forEach(function (spot) { if (spot !== except) self.close(spot); });
    }

    /* put the card below the dot (or above it in the lower half), clamped inside the photo,
       and grow it from the dot's exact position */
    place(spot, card) {
      var box = this.getBoundingClientRect();
      var dotX = (parseFloat(spot.style.left) / 100) * box.width;
      var dotY = (parseFloat(spot.style.top) / 100) * box.height;
      var w = card.offsetWidth;
      var h = card.offsetHeight;
      var left = Math.max(EDGE, Math.min(box.width - w - EDGE, dotX - w / 2));
      var below = dotY < box.height * 0.55;
      var top = below ? dotY + GAP + 8 : dotY - GAP - 8 - h;
      top = Math.max(EDGE, Math.min(box.height - h - EDGE, top));
      card.style.left = left - dotX + 'px';
      card.style.top = top - dotY + 'px';
      card.style.transformOrigin = (dotX - left) + 'px ' + (dotY - top) + 'px';
    }

    revealOnce() {
      var self = this;
      if (!('IntersectionObserver' in window)) { this.classList.add('is-visible'); return; }
      var observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        self.classList.add('is-visible');
        observer.disconnect();
      }, { threshold: 0.4 });
      observer.observe(this);
    }
  }

  customElements.define('mikoo-shop-the-look', MikooShopTheLook);
})();
